import { Routes } from '@angular/router';
import { InsideComponent } from './inside.component';
import { authRoutes } from './auth/auth.routes';
import { AuthGuard } from './auth/guards/auth-guard.service';
import { PageNotFoundComponent } from './page-not-found.component';

export const appRoutes: Routes = [
    {
        path: '',
        component: InsideComponent,
        canActivate: [AuthGuard],
        children: [
            {
                path: 'entity',
                loadChildren: () => import('./entities/entities.routes').then(m => m.entitiesRoutes)
            },
            {
                path: 'powers',
                loadChildren: () => import('./powers/powers.routes').then(m => m.powersRoutes)
            },
            {
                path: 'dashboard',
                loadChildren: () => import('./dashboard/dashboard.routes').then(m => m.dashboardRoutes)
            },
            {
                path: 'static',
                loadChildren: () => import('./static/static.routes').then(m => m.staticRoutes)
            },
            {
                path: 'match',
                loadChildren: () => import('./match/match.routes').then(m => m.matchRoutes)
            },
            {
                path: 'settings',
                loadComponent: () => import('./settings.component').then(m => m.SettingsComponent)
            },
            {
                path: 'calendar',
                loadChildren: () => import('./calendar/calendar.routes').then(m => m.calendarRoutes)
            },
            {
                path: 'company_institution_lists',
                loadChildren: () => import('./lists/lists.routes').then(m => m.listsRoutes)
            },
            {
                path: 'task_manager',
                loadChildren: () => import('./task-manager/task-manager.routes').then(m => m.taskManagerRoutes)
            },
            {
                path: 'doc_process',
                loadChildren: () => import('./doc-process/doc-process.routes').then(m => m.docProcessRoutes)
            },
            {
                path: 'missing-events',
                loadChildren: () => import('./missing-events/missing-events.routes').then(m => m.missingEventsRoutes)
            },
            {
                path: 'marketcap',
                loadChildren: () => import('./market-cap/market-cap.routes').then(m => m.marketcapRoutes)
            },
            {
                path: 'shareholders',
                loadChildren: () => import('./shareholders/shareholders.routes').then(m => m.shareholdersRoutes)
            },
            {
                path: 'company_reports',
                loadChildren: () => import('./company-reports/company-reports.routes').then(m => m.companyReportsRoutes)
            },
            {
                path: 'mozenda',
                loadChildren: () => import('./mozenda/mozenda.routes').then(m => m.mozendaRoutes)
            },
            {
                path: 'estimates',
                loadChildren: () => import('./estimates/estimates.routes').then(m => m.estimatesRoutes)
            },
            {
                path: 'press_release',
                loadChildren: () => import('./press-release/press-release.routes').then(m => m.pressReleaseRoutes)
            },
            {
                path: 'news-desk-tier',
                loadChildren: () => import('./tier-settings/tier-settings.routes').then(m => m.tierSettingsRoutes)
            }
        ]
    },
    ...authRoutes,
    { path: '**', component: PageNotFoundComponent }

];
